"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import blogCacheManager from "@/lib/blogCache";

const CacheInitializer = () => {
  const pathname = usePathname();

  useEffect(() => {
    // Initialize cache system
    blogCacheManager.init();

    // Intelligent prefetching based on current route
    const initializePrefetch = async () => {
      try {
        if (pathname === "/") {
          // On homepage, prefetch first page of blogs with delay
          setTimeout(() => {
            blogCacheManager.prefetchBlogList(1);
          }, 3000);
        } else if (pathname === "/blogs") {
          // On blogs page, don't prefetch - let the page handle its own fetching
          // to avoid conflicts and duplicate fetches
          // The page will handle its own caching and prefetching logic
        } else if (pathname.startsWith("/blogs/")) {
          // On individual blog, prefetch related content
          setTimeout(() => {
            blogCacheManager.prefetchBlogList(1);
          }, 2000);
        }
      } catch (error) {
        console.error("Cache prefetch error:", error);
      }
    };

    initializePrefetch();
  }, [pathname]);

  // This component doesn't render anything
  return null;
};

export default CacheInitializer;
